(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-swanta-header]');
    if (!root) return;
    var drawer = document.querySelector('[data-swanta-drawer]');
    // Move the drawer to <body> so no section's stacking context can cover it.
    if (drawer && drawer.parentNode !== document.body) { document.body.appendChild(drawer); }

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var b = document.querySelector('[data-swanta-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var b = document.querySelector('[data-swanta-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('[data-swanta-drawer-open]').forEach(function (el) {
      el.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-swanta-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Drawer accordions
    document.querySelectorAll('[data-swanta-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.swanta-drawer__group');
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Desktop mega: keyboard/tap support (hover handled in CSS)
    document.querySelectorAll('[data-swanta-mega] > .swanta-nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 990px)').matches) {
          var item = link.closest('[data-swanta-mega]');
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            document.querySelectorAll('[data-swanta-mega].is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-swanta-mega]')) {
        document.querySelectorAll('[data-swanta-mega].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var l = o.querySelector('.swanta-nav__link'); if (l) l.setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swanta-face-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-swanta-fit]');
    if (!root) return;

    var resultWrap = root.querySelector('[data-swanta-result]');
    var cardsWrap = root.querySelector('[data-swanta-cards]');

    // Public API — Phase 2 selfie ML can call window.swantaShowResult('oval')
    window.swantaShowResult = function (key) {
      var target = root.querySelector('[data-swanta-result-for="' + key + '"]');
      if (!target) return;
      root.querySelectorAll('[data-swanta-result-for]').forEach(function (el) { el.hidden = true; });
      target.hidden = false;
      resultWrap.hidden = false;
      resultWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    function resetResult() {
      resultWrap.hidden = true;
      root.querySelectorAll('[data-swanta-result-for]').forEach(function (el) { el.hidden = true; });
      cardsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    root.querySelectorAll('[data-swanta-card]').forEach(function (card) {
      card.addEventListener('click', function () { window.swantaShowResult(card.getAttribute('data-swanta-card')); });
    });
    root.querySelectorAll('[data-swanta-reset]').forEach(function (b) { b.addEventListener('click', resetResult); });

    // ---- Quiz ----
    var quiz = root.querySelector('[data-swanta-quiz]');
    if (quiz) {
      var scores = {};
      var stepIndex = 0;
      var steps = quiz.querySelectorAll('[data-swanta-step]');
      var bar = quiz.querySelector('[data-swanta-quiz-bar]');
      var totalQuestions = steps.length - 1; // last step is the calc screen

      function openQuiz() { scores = {}; stepIndex = 0; showStep(0); quiz.hidden = false; document.body.style.overflow = 'hidden'; }
      function closeQuiz() { quiz.hidden = true; document.body.style.overflow = ''; }
      function showStep(i) {
        steps.forEach(function (s, idx) { s.hidden = idx !== i; });
        if (bar) bar.style.width = Math.round(((i + 1) / steps.length) * 100) + '%';
      }
      function addWeights(str) {
        str.split(',').forEach(function (pair) {
          var kv = pair.split(':'); var k = kv[0].trim(); var v = parseInt(kv[1], 10) || 0;
          scores[k] = (scores[k] || 0) + v;
        });
      }
      function finish() {
        var best = null, bestVal = -1;
        Object.keys(scores).forEach(function (k) { if (scores[k] > bestVal) { bestVal = scores[k]; best = k; } });
        // Fall back to first available card if best has no matching block
        if (!root.querySelector('[data-swanta-result-for="' + best + '"]')) {
          var first = root.querySelector('[data-swanta-result-for]');
          if (first) best = first.getAttribute('data-swanta-result-for');
        }
        setTimeout(function () { closeQuiz(); window.swantaShowResult(best); }, 900);
      }

      root.querySelectorAll('[data-swanta-quiz-start]').forEach(function (b) { b.addEventListener('click', openQuiz); });
      quiz.querySelectorAll('[data-swanta-quiz-close]').forEach(function (b) { b.addEventListener('click', closeQuiz); });
      quiz.querySelectorAll('.swanta-quiz__opts button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addWeights(btn.getAttribute('data-weight') || '');
          stepIndex++;
          if (stepIndex < totalQuestions) { showStep(stepIndex); }
          else { showStep(totalQuestions); finish(); }
        });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !quiz.hidden) closeQuiz(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swanta-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-swanta-header]');
    if (!root) return;
    var drawer = document.querySelector('[data-swanta-drawer]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var b = document.querySelector('[data-swanta-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var b = document.querySelector('[data-swanta-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('[data-swanta-drawer-open]').forEach(function (el) {
      el.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-swanta-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Drawer accordions
    document.querySelectorAll('[data-swanta-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.swanta-drawer__group');
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Desktop mega: keyboard/tap support (hover handled in CSS)
    document.querySelectorAll('[data-swanta-mega] > .swanta-nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 990px)').matches) {
          var item = link.closest('[data-swanta-mega]');
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            document.querySelectorAll('[data-swanta-mega].is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-swanta-mega]')) {
        document.querySelectorAll('[data-swanta-mega].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var l = o.querySelector('.swanta-nav__link'); if (l) l.setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
